// extracted by mini-css-extract-plugin
var _1 = "inventorySummary-module__card-content";
var _2 = "inventorySummary-module__container";
export { _1 as "card-content", _2 as "container" }
